import React, { useState } from "react";
import { useDrop } from "react-dnd";
import Tippy from "@tippyjs/react";
import Xarrow, { Xwrapper, useXarrow } from "react-xarrows";
import { useLoading, Rings } from "@agney/react-loading";
import { delete_step, get_metadata_info } from "./Api";
import Modal from "./Modal_Components/Modal";
import { useEffect } from "react";

export function Content() {
  const { containerProps, indicatorEl } = useLoading({
    loading: true,
    indicator: <Rings width="100" />,
  });

  return <section {...containerProps}>{indicatorEl}</section>;
}

const Drop_Action_Node = (props) => {
  const updateXarrow = useXarrow();

  // Actions

  const [{ action_isOver, result }, action_drop] = useDrop({
    accept: "action_card",
    drop: (item, monitor) => {

      if (item.category == "App") {
        props.modal_props(
          true,
          true,
          "",
          props.source_id,
          props.conditional_node,
          props.path,
          item.name,
          item.category
        );
      } else {
        get_metadata_info(item.id)
          .then((response) => {
            if (
              response.variables.length == 0 &&
              response.conditionSupported == false
            ) {
              //do a post call

              props.conditional_node
                ? props.add_step(
                  null,
                  null,
                  { isAction: true, isconditional: true, id: item.id },
                  "",
                  props.path,
                  props.source_id
                )
                : props.add_step(
                  null,
                  null,
                  { isAction: true, isconditional: false, id: item.id },
                  ""
                );
            } else {
              props.modal_props(
                true,
                true,
                item.id,
                props.source_id,
                props.conditional_node,
                props.path,
                item.name,
                item.category
              );
            }
          })
          .catch((e) => { })
      }
    },
    collect: (monitor) => ({
      action_isOver: !!monitor.isOver(),
    }),
  });

  return (
    <a>
      <div
        className="card mb-3 kw_node_card_drop"
        id={props.id}
        ref={action_drop}
      >
        <div className="kw_node_card-header_drop">{props.name}</div>
        <div className="kw_node_card-body_drop">
          <div className="first-body-section_drop"></div>
        </div>
      </div>
    </a>
  );
};

export default Drop_Action_Node;
